//libraries
import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Navbar, Container, Nav, Image, Dropdown, NavDropdown, Button, Tab, Modal, Form, InputGroup, FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, Redirect, Route, Switch, useHistory, useRouteMatch, useParams } from 'react-router-dom';
import ReactGA from 'react-ga4'
import Cookies from 'universal-cookie';

//components
import FooterMenuAccess from '../../components/functionalComponents/DashboardLayout/FooterMenu';
import NavbarMarket from '../../components/functionalComponents/baseLayout/navbar';

//assets
import { faLinkedin, faReddit } from '@fortawesome/free-brands-svg-icons';

import succesImage from '../../assets/img/ilustraciones/ilustracion_computadoraExito.svg'
import liveImage from '../../assets/img/ilustraciones/Ilustracion_Live.svg'
import submitedImage from '../../assets/img/ilustraciones/ilustracion_certificacion_arrow.svg'
import retiroImage from '../../assets/img/ilustraciones/ilustracion_retiro.svg'
import deleteIcon from '../../assets/img/ui_icons/icono_delete_red.svg'
// import rejectedImage from '../../assets/img/ilustraciones/Ilustración_añadidoExito.svg'
// import Image from '../../assets/img/ilustraciones/Ilustración_añadidoExito.svg'

import tester from '../../assets/img/ilustraciones/Ilustracion_tester.svg'
import icon_trash from '../../assets/img/ui_icons/icono_delete.svg'
import favicon from '../../assets/img/Favicon_AVAP_Marketplace.png'
import icon_cloud from '../../assets/img/AVAP_Cloud.svg'
import icon_dev from '../../assets/img/logos/icono_DSs.svg'
import defaultImage from '../../assets/img/ui_icons/noIcon.svg'

//dummy data
import countriesData from './countries.json';
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import { map } from 'd3';

import SessionService from '../../services/SessionsService';



const MarketplaceStoreDetails = () => {


    const [isLoggedIn, setLogged] = useState(false);
    const cookies = new Cookies();
    const history = useHistory();


    const { app, version } = useParams();
    const [appData, setAppData] = useState({
        api_product_id: 0, name: '', icon: '', devName: '', price: 0, overview: '', documentation: '', features: '', terms_of_use: '',
        tags: [], installations: 0, stars: 0, creation_date: '', last_modification_date: '', project_name: '', profilePicture: '', version: '',
        social_media: { 'linkedin': '', 'reddit': '', 'x': '' }, status: '', devEmail: '', support_mail: '', country: ''
    });


    const isAppDataIncomplete = () => {
        // Verifica si alguno de los campos esenciales está vacío
        return (
            !appData.name ||
            !appData.icon ||
            !appData.devName ||
            !appData.overview ||
            !appData.documentation ||
            !appData.features ||
            !appData.terms_of_use ||
            !appData.creation_date ||
            !appData.version ||
            !appData.country
        );
    };


    const [testers, setTesters] = useState([{
        "tester": "",
        "sent_date": "",
        "status": ""
    }]);
    const [ap_history, setAPHistory] = useState([]);
    const [formData, setFormData] = useState({
        name: "",
        image: "",
        price: "",
        price_currency: "",
        price_period: "",
        free_trial: "",
        category: "",
        overview: "",
        features: "",
        terms_of_use: "",
        documentation: "",
        web_api_project: "",
        support_mail: ""
    });
    const [socialsData, setSocialsData] = useState({
        'linkedin': '',
        'reddit': '',
        'x': ''
    });

    const [fileName, setFilename] = useState("Choose file...")
    const [selectedImage, setSelectedImage] = useState(null);
    const [disabledButtonSendImg, setDisabledButtonSendImg] = useState(false);


    const getUrl = (value) => {
        if (value) {
            const substrings = value.split('/')

            return substrings.length === 1
                ? value
                : substrings.slice(0, -1).join('/')
        } else {
            return ''
        }

    }
    const getAppData = async () => {
        try {
            const result = (await ObexRequestHandler.get(`/api_product_info?api_product_id=${app}&api_product_version=${version.replace(/\+/g, '.')}`)).data[0];

            result.creation_date = new Date(result.creation_date).toLocaleDateString();
            result.last_modification_date = new Date(result.last_modification_date).toLocaleDateString();
            if (result.country) {
                setCountry([])
                const _countries = result.country.split(',');

                setCountry(_countries);

            }
            if (result.tags) {

                setKeywords(result.tags);
            }
            if (!result.social_media) {
                result['social_media'] = { 'linkedin': '', 'reddit': '', 'x': '' }
            }
            setAppData(result);
            // console.log('App Data:', result);
        } catch (error) {
            console.error('ERROR FETCHING APP DATA ', error);
        }
    }

    const getTesters = async () => {
        try {
            const result = (await ObexRequestHandler.get(`/get_testers_for_ap?api_product_id=${app}&version=${version.replace(/\+/g, '.')}`)).data;
            setTesters(result);
            // console.log('List of testers:', result);
        } catch (error) {
            setTesters([]);

            console.error('ERROR FETCHING Testers', error);
        }
    }

    const removeTester = async (testerEmail) => {
        try {
            // Modificación de la solicitud DELETE
            await ObexRequestHandler.delete('/delete_tester',{
                    email: testerEmail,
                    api_product_id: appData.api_product_id,
                    version: appData.version
                }
            );

            // Actualiza la lista de testers después de eliminar
            await getTesters();
            alert(`Tester ${testerEmail} Successfully deleted.`);
        } catch (error) {
            console.error('Error deleting the tester:', error);
            alert('There was an error deleting the tester.');
        }
    };

    const isEmailAlreadyInvited = (email) => {
        return testers.some(tester => tester.tester === email);
    };

    const getAPHistory = async () => {
        try {
            const result = (await ObexRequestHandler.get(`/get_api_product_history?api_product_id=${app}&version=${version.replace(/\+/g, '.')}`)).data;
            setAPHistory(result);
            // console.log('API History:', result);
        } catch (error) {
            setAPHistory([]);

            console.error('ERROR FETCHING Testers', error);
        }
    }

    const retireApiProduct = async (event) => {
        event.preventDefault(); // Evita el comportamiento predeterminado del formulario
        try {
            let payload = {
                "api_product_id": app,
                "version": version.replace(/\+/g, '.')
            }
            await ObexRequestHandler.post(`/retire_api_product`, payload)
            getAppData();
            getAPHistory();
        } catch (error) {
            console.error('ERROR FETCHING Testers', error);
        }
    }


    const publishApiProduct = async (event) => {
        event.preventDefault(); // Evita el comportamiento predeterminado del formulario
        try {
            let payload = {
                "api_product_id": app,
                "version": version.replace(/\+/g, '.')
            }
            await ObexRequestHandler.post(`/publish_api_product`, payload)
            getAppData();
            getAPHistory();
        } catch (error) {
            console.error('ERROR FETCHING Testers', error);
        }
    }

    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-5J60GTNR8T');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: `Avap Marketplace ${app} APP Detail` });
            }
    
    }, [])

    useEffect(() => {
        // favicon
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
        const user = cookies.get('101Obex');

        if (!user) {
            // Si no existe, redirigir al login
            history.push('/login');
        }
        getAppData();
        getTesters();
        getAPHistory();
        // favicon
        return () => {
            document.head.removeChild(link);
        };
    }, []);

    /////////////////////////////////////////////////////////////////////////////////////////////////////////



    //Email dinámico
    // Guardar la lista de correos electrónicos
    const [emails, setEmails] = useState(['']);
    const [sentEmails, setSentEmails] = useState([]); // Estado para guardar  correos  enviados test

    // Función para añadir un nuevo input de email
    const addEmailField = () => {
        const lastEmail = emails[emails.length - 1].trim();

        // Verificar si el último correo está vacío
        if (!lastEmail) {
            alert("The email field is empty. Please enter a valid email.");
            return;
        }

        // Verificar si el correo ya ha sido invitado
        if (isEmailAlreadyInvited(lastEmail)) {
            alert("This email has already been invited.");
            return;
        }

        // Verificar si el correo está duplicado en la lista actual
        if (emails.slice(0, -1).includes(lastEmail)) {
            alert("This email is already duplicated in the list.");
            return;
        }

        // Si todo está bien, añade un nuevo campo de correo vacío
        setEmails([...emails, '']);
    };

    // Función para enviar las invitaciones
    const handleCombinedClick = async (event) => {
        event.preventDefault();

        const lastEmail = emails[emails.length - 1].trim();

        // Verificar si el último correo está vacío antes de enviar
        if (!lastEmail) {
            alert("The last email field is empty. Please enter a valid email.");
            return;
        }

        // Verificar si el correo ya ha sido invitado
        if (isEmailAlreadyInvited(lastEmail)) {
            alert(`The last email field is empty. Please enter a valid email`);
            return;
        }

        // Verificar si el correo está duplicado en la lista
        if (emails.slice(0, -1).includes(lastEmail)) {
            alert("There are duplicate emails in the list. Please correct the errors.");
            return;
        }

        // Si no hay correos duplicados o vacíos, enviar las invitaciones
        sendInvitations(event);
    };


    // Función para manejar el cambio de los inputs
    const handleEmailChange = (index, event) => {
        const updatedEmails = [...emails];
        updatedEmails[index] = event.target.value;
        setEmails(updatedEmails);
    };

    // Función para eliminar un input de email
    const removeEmailField = (index) => {
        const updatedEmails = emails.filter((_, i) => i !== index);
        setEmails(updatedEmails);
    };

    // Función para enviar las invitaciones
    const sendInvitations = async (event) => {
        event.preventDefault();

        // Filtrar los correos que ya han sido invitados
        const alreadyInvitedEmails = emails.filter(email => isEmailAlreadyInvited(email));

        if (alreadyInvitedEmails.length > 0) {
            // Si hay correos ya invitados, muestra un mensaje de alerta y evita el envío
            alert(`The following emails have already been invited: ${alreadyInvitedEmails.join(', ')}`);
            return; // Evita el envío de la invitación si hay correos ya invitados
        }

        // Si no hay correos ya invitados, continúa con el envío
        let payload = {
            "emails": emails,
            "api_product_id": appData.api_product_id,
            "version": appData.version
        };

        try {
            await ObexRequestHandler.post('/invite_testers', payload);
            setSentEmails(emails); // Almacena los correos enviados
            getTesters(); // Actualiza la lista de testers después de enviar la invitación

            // Limpia el estado de emails después de enviar
            setEmails(['']);
            handleShowInvitations(); // Mostrar el modal solo si el envío fue exitoso
        } catch (error) {
            console.error('Error sending the invitations:', error);
            alert('There was an error sending the invitations.');
        }
    };

    const startCertification = async (event) => {
        event.preventDefault();
        await ObexRequestHandler.get(`/start_certification_process?api_product_id=${app}&version=${version.replace(/\+/g, '.')}`)
        getAppData();
        getAPHistory();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleChangeSM = (e) => {
        const { name, value } = e.target;
        setSocialsData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };
    const handleSubmitForm = async () => {

        try {
            let payload = formData;
            let countriesStr = '';
            if (country.length > 0) {
                for (let index = 0; index < country.length; index++) {
                    const element = country[index];
                    countriesStr += element + ','
                }
                countriesStr = countriesStr.substring(0, countriesStr.length - 1)
                payload['country'] = countriesStr;
            }
            payload['tags'] = Keywords
            payload['social_media'] = socialsData;
            payload['api_product_id'] = app
            payload['version'] = version.replace(/\+/g, '.')

            if (selectedImage) {
                setDisabledButtonSendImg(true);

                const safedstring = selectedImage.toString();
                const base64SafedString = btoa(safedstring);
                payload['image'] = base64SafedString;

            }


            await ObexRequestHandler.put(`/api_product_info`, payload)
            getAppData();
            getAPHistory();
            setDisabledButtonSendImg(false);

        } catch (error) {
            console.error('ERROR Aplying changes', error);
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //Keywords
    //Prellenar con alguna keyword - solo si se requiere
    const [Keywords, setKeywords] = useState(['Avap Cloud']);
    //remover keyword
    const removeKeywords = (indexToRemove) => {
        if (appData.name == 'Draft' || appData.status == 'RejectedPar') {
        const updatedTags = Keywords.filter((_, index) => index !== indexToRemove);
        setKeywords(updatedTags);
        }
    };
    //añadir keyword
    const addTags = (event) => {
        if (event.target.value !== "") {
            const newTag = event.target.value;
            // console.log("Nuevo tag ingresado:", newTag); // test
            const updatedTags = [...Keywords, newTag];
            setKeywords(updatedTags);
            event.target.value = "";
        }
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////
    // Country Select
    const [country, setCountry] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);

    // Extraer los nombres de los países desde el JSON y agregar "All Countries"
    const allTags = ['All Countries', ...countriesData.map(country => country.name)];

    // Función para añadir un nuevo tag
    const addCountry = (countryName) => {
        if (countryName && !country.includes(countryName)) {
            setCountry([...country, countryName]);
            setInputValue('');
            setSuggestions([]); // Limpiar sugerencias
        }
    };

    // Función para eliminar un tag
    const removeTag = (tagToRemove) => {
        if (appData.status == 'Draft' || appData.status == 'RejectedPar'){
        setCountry(country.filter(tag => tag !== tagToRemove));
        }
    };

    // Función para manejar el cambio en el input
    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        if (value && !country.includes('All Countries')) { // Solo mostrar sugerencias si no se ha seleccionado "All Countries"
            // Filtrar sugerencias basadas en el input y excluir tags ya seleccionados
            const filteredSuggestions = allTags
                .filter(tag => tag.toLowerCase().includes(value.toLowerCase()))
                .filter(tag => !country.includes(tag)); // Excluir tags seleccionados
            setSuggestions(filteredSuggestions);
        } else {
            setSuggestions([]);
        }
    };

    // Función para manejar el foco en el input
    const handleInputFocus = () => {
        if (!country.includes('All Countries')) { // Mostrar todas las sugerencias solo si "All Countries" no está seleccionado
            const filteredSuggestions = allTags.filter(tag => !country.includes(tag));
            setSuggestions(filteredSuggestions);
        }
    };

    // Función para manejar la selección de un país
    const handleSuggestionClick = (countryName) => {
        addCountry(countryName); // Usar el nombre del país para añadirlo como tag
        setMuestra(false);
    };
    const handleSubmit = (e) => {
        e.preventDefault(); // Prevenir el comportamiento por defecto del formulario

        // Verificar si el evento proviene del input con ID #countriesSelect
        const inputElement = document.getElementById('countriesSelect');
        if (e.target === inputElement) {
            // Comprobar si el inputValue es un país válido o "All Countries"
            if (allTags.includes(inputValue) && !country.includes(inputValue)) {
                if (inputValue === 'All Countries') {
                    setCountry([inputValue]); // Agregar "All Countries" y evitar más adiciones
                } else {
                    addCountry(inputValue); // Añadir solo si es un país válido
                }
            } else {
                alert('Please select a valid country from the list.'); // Mensaje de alerta si no es válido
            }
        }
    };
    //////////////////////////////////////////////////////////////////////////////

    //modal triggers
    const [saveForm, setSaveForm] = useState(false);
    const [Invitations, setInvitations] = useState(false);
    const [certInicio, setCertInicio] = useState(false);
    const [certPublicada, setCertPublicada] = useState(false);
    const [certRetiro, setCertRetiro] = useState(false);
    const [certTryagain, setCertTryagain] = useState(false);
    const [muestra, setMuestra] = useState(false);

    // modal formulario al guardar datos
    const changeApiName = (e) => {
        const newMail = e.target.value;
        setMail(newMail);
    };

    const changePass = (e) => {
        const newPass = e.target.value;
        setPassword(newPass);
    };

    const ChangeRePass = (e) => {
        const newPass = e.target.value;
        changerepPass(newPass);
    };



    const handleCloseSaveForm = () => setSaveForm(false);
    const handleShowSaveForm = (event) => {
        handleSubmitForm();
        setSaveForm(true);
        // saveAPData(event);

    }

    const handleCertification = (event) => {
        startCertification(event);
        handleShowCertInicio();
    };

    // modales certificacion
    //modal inicio
    const handleCloseCertInicio = () => setCertInicio(false);
    const handleShowCertInicio = () => setCertInicio(true);

    //modal API publicada
    const handleCloseCertPublicada = () => setCertPublicada(false);
    const handleShowCertPublicada = (event) => {
        setCertPublicada(true);
        publishApiProduct(event);
    };



    //modal Retiro del MArketplace
    const handleCloseCertRetiro = () => setCertRetiro(false);

    const handleShowCertRetiro = (event) => {
        setCertRetiro(true);
        retireApiProduct(event);
    };

    //modal inicio
    const handleCloseCertTryagain = () => setCertTryagain(false);
    const handleShowCertTryagain = (event) => {
        setCertTryagain(true);
        startCertification(event);
    };



    // modal al mandar invitaciones
    const handleCloseInvitations = () => setInvitations(false);
    const handleShowInvitations = () => setInvitations(true);

    ////////////////////////////////////////////////////////////////////////////////////

    //test
    const handleCombinedClick = (event) => {
        event.preventDefault(); // Evita el comportamiento predeterminado del botón

        // Filtrar correos que ya han sido invitados
        const alreadyInvitedEmails = emails.filter(email => isEmailAlreadyInvited(email));

        if (alreadyInvitedEmails.length > 0) {
            // Si hay correos ya invitados, muestra una alerta o mensaje y evita abrir el modal
            alert(`The following emails have already been invited.: ${alreadyInvitedEmails.join(', ')}`);
            return; // Detiene la ejecución si ya hay correos invitados
        }

        // Si no hay correos ya invitados, continúa con el envío y abre el modal
        sendInvitations(event);
        handleShowInvitations(); // Abre el modal
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setSelectedImage(reader.result);
            };
            reader.readAsDataURL(file);
            // console.log(file);
            setFilename(file.name);
        }
    };








    return (
        <>

            <NavbarMarket />

            <div id='mktDetails' className="w-100 bg-antiflash">
                <header className='container'>
                    <div className="row" id='headerInfo'>
                        <div className="col-12">
                            <div className="headerInfoWrapper">
                                <div className="iconContainer">
                                    <Image
                                        src={appData.icon && appData.icon.trim() !== '' ? atob(appData.icon) : defaultImage}
                                        alt="API Logo"
                                    />

                                </div>
                                <div className="infoContainer">
                                    <p className='titulo'>{appData.name}</p>
                                    <p className='devName m-0'>{appData.devName}</p>
                                    <p>Version {appData.version}</p>


                                    {/* <a className='linkHeader' href="http://">Trouble installing?</a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"> <hr className='margin-25' /> </div>
                    </div>

                    <div className="row mt-n10">
                        <div className="col-md-12 d-flex justify-content-between">
                            <Image src={icon_cloud} className='h-23' />
                            <p>Category</p>
                        </div>
                    </div>

                </header>



                <div id='details' className="container-fluid mb-4">
                    <Tab.Container id="detailsTabs" defaultActiveKey="editable" >
                        <Row className=''>
                            <div className="w-100 bg-white navShadow">
                                <Container id='tabsNavbar'>
                                    <Row>
                                        <Col sm={12}>
                                            <Nav className="flex detailsNav">
                                                <Nav.Item>
                                                    <Nav.Link eventKey="editable">Information</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="certification">Certification</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="invitation">Invitation to Testers
                                                        {/* simular las invitaciones, aunque realmente tendria que regresar las invitaciones aceptadas. */}
                                                        {testers.length > 0 && (
                                                            <span>  ({testers.length}) </span>
                                                        )}</Nav.Link>
                                                </Nav.Item>
                                            </Nav>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>

                            <Container fluid id='tabsContent' className='pb-6' >
                                <Row>
                                    <Col sm={12} className='p-0'>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="editable">
                                                <div className="container marginContent">
                                                    <div className="row">
                                                        <div className="col-md-12 ">
                                                            <p className='subtitulo'>Basic Information</p>
                                                            <hr />

                                                            <Form>


                                                                <Form.Group controlId="formProjectName">
                                                                    <Form.Label>API Product Name</Form.Label>
                                                                    <Form.Control disabled={(appData.status !== 'Draft'  && appData.status !== 'RejectedPar')} type="text" placeholder='API Product Name' defaultValue={`${appData.name}`} name='name' onChange={handleChange} value={formData.name != '' ? formData.name : appData.name} />
                                                                </Form.Group>


                                                                <p className='subtitulo mt-4'>Description, Legal, and Documentation</p>
                                                                <hr />
                                                                <Form.Group controlId="exampleForm.ControlTextarea1">
                                                                    <Form.Label>Description of the API Product - Overview</Form.Label>
                                                                    <Form.Control disabled={appData.status !== 'Draft'  && appData.status !== 'RejectedPar'} name='overview' as="textarea" placeholder='Overview' rows={3} defaultValue={appData.overview} onChange={handleChange} value={formData.overview != '' ? formData.overview : appData.overview} />
                                                                </Form.Group>
                                                                <Form.Group controlId="exampleForm.ControlTextarea1">
                                                                    <Form.Label>Description of the API Product - Features</Form.Label>
                                                                    <Form.Control disabled={appData.status !== 'Draft'  && appData.status !== 'RejectedPar'}  name='features' as="textarea" placeholder='Features' rows={3} defaultValue={appData.features} onChange={handleChange} value={formData.features != '' ? formData.features : appData.features} />
                                                                </Form.Group>
                                                                <Form.Group controlId="exampleForm.ControlTextarea1">
                                                                    <Form.Label>Description of the API Product - Terms of use</Form.Label>
                                                                    <Form.Control disabled={appData.status !== 'Draft' && appData.status !== 'RejectedPar'} name='terms_of_use' as="textarea" placeholder='Terms of use' rows={3} defaultValue={appData.terms_of_use} onChange={handleChange} value={formData.terms_of_use != '' ? formData.terms_of_use : appData.terms_of_use} />
                                                                </Form.Group>
                                                                <Form.Group controlId="exampleForm.ControlTextarea1">
                                                                    <Form.Label>Documentation</Form.Label>
                                                                    <Form.Control disabled={appData.status !== 'Draft'} name='documentation' as="textarea" placeholder='Documentation' rows={3} defaultValue={appData.documentation} onChange={handleChange} value={formData.documentation != '' ? formData.documentation : appData.documentation} />
                                                                </Form.Group>

                                                                <p className='subtitulo mt-4'>Logo</p>
                                                                <hr />

                                                                <Form.File
                                                                
                                                                    id="custom-file"
                                                                    label={fileName}
                                                                    className='mt-3'
                                                                    disabled={disabledButtonSendImg || (appData.status !== 'Draft'  && appData.status !== 'RejectedPar')}
                                                                    onChange={handleFileChange} 
                                                                    custom
                                                                />
                                                                <span className='pt-2'>For optimal display, please ensure your logo is sized at 300x300 pixels and does not exceed 5MB.</span>


                                                                <p className='subtitulo mt-4'>Country</p>
                                                                <hr />


                                                                <InputGroup id='countriesSelect'>
                                                                    <Form.Control
                                                                        type="text"
                                                                        value={inputValue}
                                                                        onChange={handleInputChange}
                                                                        onClick={()=>{setMuestra(!muestra); console.log(muestra)}}
                                                                        onFocus={handleInputFocus} // Muestra todas las sugerencias al hacer foco
                                                                        placeholder="Start typing the country name..."
                                                                        disabled={country.includes('All Countries') || (appData.status !== 'Draft' && appData.status !== 'RejectedPar')} // Deshabilita el input si "All Countries" está seleccionado 

                                                                    />
                                                                    {/* <InputGroup.Prepend>
                                                                        <button
                                                                            className='btn-brick'
                                                                            type="submit"
                                                                            onClick={handleSubmit}
                                                                            disabled={country.includes('All Countries')}>
                                                                            Add
                                                                        </button>
                                                                    </InputGroup.Prepend> */}
                                                                </InputGroup>
                                                                
                                                                <div className="country-selector">
                                                                    {muestra && suggestions.length > 0 && !country.includes('All Countries') && ( // Mostrar sugerencias solo si "All Countries" no está seleccionado
                                                                        <ul className="suggestions">
                                                                            {suggestions.map((suggestion, index) => (
                                                                                <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
                                                                                    {suggestion} {/* Muestra el nombre del país */}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                    <div className="tags">
                                                                        {country.map((tag, index) => (
                                                                            <span key={index} className="tag">
                                                                                {tag}
                                                                                <button type="button" onClick={() => removeTag(tag)}> <span>x</span> </button>
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                    {/* <p>Selected countries: {country.join(', ')}</p> */}
                                                                </div>


                                                                <p className='subtitulo mt-4'>Keywords for categories </p>
                                                                <hr />

                                                                <Form.Row >
                                                                    <div className="keyword-input">
                                                                        <ul id="keyword">
                                                                            {Keywords.map((tag, index) => (
                                                                                <li key={index} className="keyword">
                                                                                    <span className="keyword-title">{tag}</span>
                                                                                    <span className="keyword-close-icon" onClick={() => removeKeywords(index)}>
                                                                                        x
                                                                                    </span>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                        <input
                                                                            type="text"
                                                                            onKeyUp={(event) => (event.key === "Enter" ? addTags(event) : null)}
                                                                            placeholder="Press enter to add keyword"
                                                                            disabled={appData.status !== 'Draft'  && appData.status !== 'RejectedPar'}
                                                                        />
                                                                    </div>
                                                                </Form.Row>

                                                                <p className='subtitulo mt-4'>Web and social media</p>
                                                                <hr />
                                                                <Form.Group controlId="formProjectName">
                                                                    <Form.Label>Developer website (Optional)</Form.Label>
                                                                    <Form.Control disabled={appData.status !== 'Draft'  && appData.status !== 'RejectedPar'} type="text" placeholder="www.example.com" defaultValue={appData.url} name='web_api_project' onChange={handleChange} value={formData.web_api_project != '' ? formData.web_api_project : getUrl(appData.url)} />
                                                                </Form.Group>
                                                                <Form.Group controlId="formProjectName">
                                                                    <Form.Label>Support contact (Optional)</Form.Label>
                                                                    <Form.Control disabled={appData.status !== 'Draft'  && appData.status !== 'RejectedPar'} type="text" placeholder="support@example.com" defaultValue={appData.devEmail} name='support_mail' onChange={handleChange} value={formData.support_mail != '' ? formData.support_mail : appData.support_mail} />
                                                                </Form.Group>
                                                                <Form.Row className=''>
                                                                    <Form.Group as={Col} controlId="formDevName">
                                                                        <Form.Label>Social Media (Optional)</Form.Label>
                                                                        <InputGroup className="mb-2">
                                                                            <InputGroup.Prepend>
                                                                                <InputGroup.Text><FontAwesomeIcon icon={faLinkedin} /></InputGroup.Text>
                                                                            </InputGroup.Prepend>
                                                                            <FormControl disabled={appData.status !== 'Draft'  && appData.status !== 'RejectedPar'} type='text' placeholder="linkedin.com/in" defaultValue={appData.social_media['linkedin']} name='linkedin' onChange={handleChangeSM} value={socialsData.linkedin != '' ? socialsData.linkedin : appData.social_media.linkedin} />
                                                                        </InputGroup>
                                                                    </Form.Group>

                                                                    <Form.Group as={Col} controlId="formDomain">
                                                                        <Form.Label>&nbsp;</Form.Label>
                                                                        <InputGroup className="mb-2">
                                                                            <InputGroup.Prepend>
                                                                                <InputGroup.Text><FontAwesomeIcon icon={faReddit} /></InputGroup.Text>
                                                                            </InputGroup.Prepend>
                                                                            <FormControl disabled={appData.status !== 'Draft'  && appData.status !== 'RejectedPar'} type='text' placeholder="reddit.com/example" defaultValue={appData.social_media['reddit']} name='reddit' onChange={handleChangeSM} value={socialsData.reddit != '' ? socialsData.reddit : appData.social_media.reddit} />
                                                                        </InputGroup>
                                                                    </Form.Group>

                                                                </Form.Row>
                                                                <Form.Row className='mt-negative'>
                                                                    <Form.Group as={Col} controlId="formDevName">
                                                                        <Form.Label>&nbsp;</Form.Label>
                                                                        <InputGroup className="mb-2">
                                                                            <InputGroup.Prepend>
                                                                                <InputGroup.Text> <span className='txt-bold svgIcon'>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                                        <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z" />
                                                                                    </svg></span></InputGroup.Text>
                                                                            </InputGroup.Prepend>
                                                                            <FormControl disabled={appData.status !== 'Draft'  && appData.status !== 'RejectedPar'} type='text' placeholder="@exampleAPIProject" defaultValue={appData.social_media['x']} name='x' onChange={handleChangeSM} value={socialsData.x != '' ? socialsData.x : appData.social_media.x} />
                                                                        </InputGroup>
                                                                    </Form.Group>
                                                                </Form.Row>

                                                                <p className='subtitulo mt-4'>Price and Period</p>
                                                                <hr />

                                                                <Form.Row className=''>
                                                                    <Form.Group as={Col} controlId="formDevName">
                                                                        <Form.Label>Price</Form.Label>
                                                                        <InputGroup className="mb-2" style={{maxWidth: `${(formData.price!='0' && formData.price!='') ? '100%':'50%'}` }}>
                                                                            <InputGroup.Prepend >
                                                                                <InputGroup.Text> USD</InputGroup.Text>
                                                                            </InputGroup.Prepend>
                                                                            <FormControl disabled={appData.status !== 'Draft'  && appData.status !== 'RejectedPar'} type='number' placeholder="$15" defaultValue={appData.price.toString()} name='price' onChange={handleChange} value={formData.price != '' ? formData.price : appData.price.toString()} />
                                                                        </InputGroup>
                                                                    </Form.Group>
                                                                    { (formData.price != '' && formData.price != '0')  &&
                                                                    <Form.Group as={Col} controlId="exampleForm.ControlSelect1">
                                                                        <Form.Label>Period</Form.Label>
                                                                        <Form.Control disabled={appData.status !== 'Draft'  && appData.status !== 'RejectedPar'} as="select" defaultValue={appData.price_period} name='price_period' onChange={handleChange} value={formData.price_period != '' ? formData.price_period : appData.price_period}>
                                                                            <option>Monthly</option>
                                                                            <option>Anually</option>
                                                                            <option>One-time payment </option>
                                                                        </Form.Control>
                                                                    </Form.Group>
}
                                                                </Form.Row>
                                                                {(formData.price != '0' && formData.price!='') &&
                                                                <Row>
                                                                    <Col lg={6} className="my-1 align-items-center align-content-center">
                                                                        <Form.Group className='w-100' controlId="formDevName">
                                                                            <Form.Label>Free trial (days)</Form.Label>
                                                                            <Form.Control disabled={appData.status !== 'Draft'  && appData.status !== 'RejectedPar'} type="number" placeholder="6" defaultValue={appData.free_trial} name='free_trial' onChange={handleChange} value={formData.free_trial != '' ? formData.free_trial : appData.free_trial} />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
    }

                                                            </Form>

                                                            <button disabled={appData.status!='Draft' && appData.status!='RejectedPar'} type='submit' className='btn-ln-brick mr-3' onClick={handleShowSaveForm}>
                                                                Save Information
                                                            </button>

                                                            {/* Botón con lógica de estado y validación */}
                                                            {(appData.status !== 'Draft'  && appData.status !== 'RejectedPar') ? (
                                                                <button className='btn-brick disabled' onClick={handleCertification} disabled>Start Certification</button>
                                                            ) : (
                                                                <button
                                                                    className={`btn-brick ${isAppDataIncomplete() || appData.status === 'RejectedPar' ? 'disabled' : ''}`}
                                                                    onClick={handleCertification}
                                                                    disabled={isAppDataIncomplete()}
                                                                >
                                                                    Start Certification
                                                                </button>
                                                            )}
                                                        </div>

                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="certification">
                                                <div className="container marginContent">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="titleBar">
                                                                <p className='subtitulo'>{appData.name} </p>
                                                                <p className="float-right subtitulo">Version {appData.version}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="certStepCard">
                                                                <div className="stepCircle">

                                                                </div>
                                                                <div className="stepInfo">

                                                                </div>
                                                            </div>

                                                            <ul className="list-timeline-vertical mt-3">
                                                                {ap_history.map((item, index) => (
                                                                    item.resolved_state == 'Reviewing' ?
                                                                        <li className="list-timeline-vertical__item draft">
                                                                            <h2 className='title'>Certification process started</h2>
                                                                            <p className="message">
                                                                                Your API Product has initiated the certification process by 101OBEX.
                                                                            </p>
                                                                            <p className="date">
                                                                                {new Date(item.certification_petition_date).toLocaleString()}
                                                                            </p>

                                                                            <div className="btnWrapper d-flex justify-content-end">
                                                                                {/* <button className='btn-brick disabled'>Submited for certification</button> */}
                                                                            </div>
                                                                            <hr />
                                                                        </li>
                                                                        : item.resolved_state == 'RejectedPar' ?
                                                                            <li className="list-timeline-vertical__item rejected">
                                                                                <h2 className='title'>Submission rejected</h2>
                                                                                {/* <p className="dec">
                                                                        The API Product has initiated the certification process by 101OBEX.
                                                                    </p> */}
                                                                                <p className="message">
                                                                                    <span className="title">Submission rejected pending correction</span><br />
                                                                                    Thank you for submitting [{item.api_product_name}] to AVAP Marketplace. After careful review, we regret to inform you that your API Product did not meet the required criteria and has been rejected at this time.
                                                                                </p>
                                                                                <p className="date">
                                                                                    {new Date(item.certification_petition_date).toLocaleString()}
                                                                                </p>

                                                                                <div className="btnWrapper d-flex justify-content-end">
                                                                                    {index == 0 ?
                                                                                        <button className='btn-brick' onClick={handleShowCertTryagain}>Try again</button>
                                                                                        :
                                                                                        <button className='btn-brick disabled' onClick={handleShowCertTryagain}>Try again</button>
                                                                                    }
                                                                                </div>
                                                                                <hr />
                                                                            </li>
                                                                            : item.resolved_state == 'RejectedCom' ?
                                                                                <li className="list-timeline-vertical__item rejected">
                                                                                    <h2 className='title'>Submission rejected</h2>
                                                                                    {/* <p className="dec">
                                                                        The API Product has initiated the certification process by 101OBEX.
                                                                    </p> */}
                                                                                    <p className="message">
                                                                                        <span className="title">Submission rejected</span><br />
                                                                                        Thank you for submitting [{item.api_product_name}] to AVAP Marketplace. After careful review, we regret to inform you that your API Product did not meet the required criteria and has been completely rejected. Please upload a new version of the API Product and start the process again.
                                                                                    </p>
                                                                                    <p className="date">
                                                                                        {new Date(item.certification_petition_date).toLocaleString()}
                                                                                    </p>

                                                                                    {/* <div className="btnWrapper d-flex justify-content-end">
                                                                                        <button className='btn-brick disabled'>Try again</button>
                                                                                    </div> */}
                                                                                    <hr />
                                                                                </li>
                                                                                : item.resolved_state == 'Approved' ?
                                                                                    <li className="list-timeline-vertical__item approved">
                                                                                        <h2 className='title'>Approved</h2>
                                                                                        <p className="dec">
                                                                                            Your API Product, [{item.api_product_name}], has been successfully approved and is now ready for publication in AVAP Marketplace.
                                                                                        </p>
                                                                                        <p className="date">
                                                                                            {new Date(item.certification_petition_date).toLocaleString()}
                                                                                        </p>

                                                                                        <div className="btnWrapper d-flex justify-content-end">
                                                                                            {index == 0 ?
                                                                                                <button className='btn-brick' onClick={handleShowCertPublicada}>Live on Marketplace</button>
                                                                                                :
                                                                                                <></>
                                                                                                /*<button className='btn-brick disabled' onClick={handleShowCertPublicada}>Live on Marketplace</button>*/
                                                                                            }
                                                                                        </div>
                                                                                        <hr />
                                                                                    </li>

                                                                                    :
                                                                                    <li className="list-timeline-vertical__item current">
                                                                                        <h2 className='title'>Live on AVAP Marketplace</h2>
                                                                                        <p className="dec">
                                                                                            Your API Product, [{item.api_product_name}], has been successfully published and is now live on AVAP Marketplace!
                                                                                        </p>
                                                                                        <p className="date">
                                                                                            {new Date(item.certification_petition_date).toLocaleString()}
                                                                                        </p>

                                                                                        <div className="btnWrapper d-flex justify-content-end">
                                                                                            {index == 0 ?
                                                                                                <button className='btn-brick' onClick={handleShowCertRetiro}>Request Removal from Marketplace</button>
                                                                                                :
                                                                                                <></>
                                                                                                //<button className='btn-brick disabled' onClick={handleShowCertRetiro}>Request Removal from Marketplace</button>

                                                                                            }
                                                                                        </div>
                                                                                        <hr />
                                                                                    </li>


                                                                ))

                                                                }




                                                                <li className="list-timeline-vertical__item draft">
                                                                    <h2 className='title'>Draft</h2>
                                                                    <p className="message">
                                                                        <span className="title">Invitation to Testers </span><br />
                                                                        It’s time to invite testers to review your API Product. At this stage, we recommend conducting technical and usability tests with the technical team.
                                                                    </p>
                                                                    <p className="date">
                                                                        {
                                                                            !isNaN(Date.parse(appData.creation_date))
                                                                                ? new Date(appData.creation_date).toLocaleString()
                                                                                : appData.creation_date
                                                                        }
                                                                    </p>

                                                                    <div className="btnWrapper d-flex justify-content-end">
                                                                        {/* <button className='btn-brick disabled'>Submited for certification</button> */}
                                                                    </div>
                                                                    <hr />
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="invitation">
                                                <div className="container marginContent">
                                                    <div className="row">
                                                        <div className="col-md-12 ">
                                                            <p className='subtitulo'>Invitation to Testers</p>
                                                            <hr />

                                                            {(appData.status !== 'Draft'  && appData.status !== 'RejectedPar') ? (
                                                                <p className="c-brick">Testers cannot be invited once the verification process has started.</p>
                                                            ) : (
                                                                <>
                                                                    {emails.map((email, index) => (
                                                                        <Form key={index}>
                                                                            <InputGroup className="mb-3">
                                                                                <Form.Control
                                                                                    type="email"
                                                                                    placeholder="Email"
                                                                                    value={email}
                                                                                    onChange={(event) => handleEmailChange(index, event)} />
                                                                                <InputGroup.Prepend>
                                                                                    {index > 0 && (
                                                                                        <Button variant="outline-secondary" onClick={() => removeEmailField(index)}>
                                                                                            <Image src={icon_trash} />
                                                                                        </Button>
                                                                                    )}
                                                                                </InputGroup.Prepend>
                                                                            </InputGroup>
                                                                        </Form>
                                                                    ))}
                                                                    <div className='float-right'>
                                                                        <button className='btn-ln-brick mr-3' onClick={addEmailField}>Add</button>
                                                                        <button className='btn-ln-brick' onClick={handleCombinedClick}>Send</button>
                                                                    </div>
                                                                </>
                                                            )}

                                                        </div>

                                                    </div>

                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p className='subtitulo mt-7'>Testers</p>
                                                            <hr />

                                                            {/* Mostrar correos enviados - faltaria agregar cuantos han aceptado ---> [1] */}
                                                            {testers.length > 0 && (
                                                                <p><span className='txt-bold'>Invitations:</span> You’ve invited {testers.length} people, and {testers.filter(tester => tester.status === 'accepted').length} have accepted. </p>
                                                            )}
                                                            <ul className='invitations'>

                                                                {testers.map((item) => (
                                                                    <li className='invitation'>
                                                                        
                                                                        <div className="dataWrapper">
                                                                            <p className="email">{item.tester}</p>
                                                                            <p className="status">
                                                                                <span
                                                                                    className={
                                                                                        item.status === 'accepted'
                                                                                            ? 'status-accepted'
                                                                                            : item.status === 'declined'
                                                                                                ? 'status-declined'
                                                                                                : 'status-pending'
                                                                                    }
                                                                                >
                                                                                    Invitation {
                                                                                        item.status === 'accepted' ? 'accepted' :
                                                                                            item.status === 'declined' ? 'declined' :
                                                                                                'sent, pending acceptance'
                                                                                    }
                                                                                

                                                                                <button style={{marginLeft:'10px'}} className='removeAcces' onClick={() => removeTester(item.tester)}><img src={deleteIcon} alt="delete icon" /></button>
                                                                                {/* <button className='removeAcces'><img src={deleteIcon} alt="delete icon" />Remove Access</button> */}
                                                                            
                                                                                </span>
                                                                            </p>
                                                                        </div>
                                                                        
                                                                    </li>
                                                                ))}
                                                                {/* <li className='invitation'>
                                                                    <div className="dataWrapper">
                                                                        <p className="email">example@tester.com</p>
                                                                        <p className="status">Invitation sent, pending acceptance</p>
                                                                    </div>
                                                                    <p className="date">01-SEP-2024 / 20:11:34 pm</p>
                                                                </li>
                                                                <li className='invitation'>
                                                                    <div className="dataWrapper">
                                                                        <p className="email">example@tester.com</p>
                                                                        <p className="status c-error">Invitation declined</p>
                                                                    </div>
                                                                    <p className="date">01-SEP-2024 / 20:11:34 pm</p>
                                                                </li>
                                                                <li className='invitation'>
                                                                    <div className="dataWrapper">
                                                                        <p className="email">example@tester.com</p>
                                                                        <p className="status">Invitation sent, pending acceptance</p>
                                                                    </div>
                                                                    <p className="date">01-SEP-2024 / 20:11:34 pm</p>
                                                                </li>    
                                                                <li className='invitation'>
                                                                    <div className="dataWrapper">
                                                                        <p className="email">example@tester.com</p>
                                                                        <p className="status">Invitation Sent</p>
                                                                    </div>
                                                                    <p className="date">01-SEP-2024 / 20:11:34 pm</p>
                                                                </li>
                                                                <li className='invitation'>
                                                                    <div className="dataWrapper">
                                                                        <p className="email">example@tester.com</p>
                                                                        <p className="status c-success">Invitation accepted</p>
                                                                    </div>
                                                                    <p className="date">01-SEP-2024 / 20:11:34 pm</p>
                                                                </li> */}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Col>

                                </Row>
                            </Container>
                        </Row>
                    </Tab.Container >
                </div >

                <FooterMenuAccess green={true} />





                {/* modal Save Form */}

                <Modal show={saveForm} onHide={handleCloseSaveForm}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <h1 className='customTitle'>Your information has been saved!</h1>
                        <Image src={succesImage} className='d-block m-auto' />
                        <p className='text-center mt-3'>The information has been successfully saved.</p>
                    </Modal.Body>
                    <Modal.Footer>

                        <button className='btn-brick' onClick={handleCloseSaveForm}>
                            Continue
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* //modales certifications*/}

                {/* //Modal Inicio*/}
                <Modal show={certInicio} onHide={handleCloseCertInicio}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <h1 className='customTitle'>¡API Product submitted for certification!</h1>
                        <Image src={submitedImage} className='d-block m-auto' />
                        <p className='text-center mt-3'>
                            We’re pleased to confirm that your API product, {appData.name}, has been successfully submitted for certification in the AVAP Marketplace.
                            Once our team reviews your submission to ensure it meets our quality and security standards, we’ll notify you immediately via email.</p>
                    </Modal.Body>
                    <Modal.Footer>

                        <button className='btn-brick' onClick={handleCloseCertInicio}>
                            Continue
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Api publicada */}
                <Modal show={certPublicada} onHide={handleCloseCertPublicada}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <h1 className='customTitle'>¡Live on AVAP Marketplace!</h1>
                        <Image src={liveImage} className='d-block m-auto' />
                        <p className='text-center mt-3'>
                            Your API product, {appData.name}, has been successfully published and is now live on AVAP Marketplace!
                        </p>
                    </Modal.Body>
                    <Modal.Footer>

                        <button className='btn-brick' onClick={handleCloseCertPublicada}>
                            Continue
                        </button>
                    </Modal.Footer>
                </Modal>


                {/* Modal Api Retiro */}
                <Modal show={certRetiro} onHide={handleCloseCertRetiro}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <h1 className='customTitle'>Removal from Marketplace your API Product</h1>
                        <Image src={retiroImage} className='d-block m-auto' />
                        <p className='text-center mt-3'>
                            We will remove your API Product from the AVAP Marketplace.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>

                        <button className='btn-brick' onClick={handleCloseCertRetiro}>
                            Continue
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Api Retiro */}
                <Modal show={certTryagain} onHide={handleCloseCertTryagain}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <h1 className='customTitle'>¡API Product submitted for certification!</h1>
                        <Image src={submitedImage} className='d-block m-auto' />
                        <p className='text-center mt-3'>The information has been successfully saved.</p>
                    </Modal.Body>
                    <Modal.Footer>

                        <button className='btn-brick' onClick={handleCloseCertTryagain}>
                            Try again
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* //modal invitatations */}

                <Modal show={Invitations} onHide={handleCloseInvitations}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <h1 className='customTitle'>Invitation sent!</h1>
                        <Image src={tester} className='d-block m-auto' />
                        <p className='text-center mt-3'>The invitation has been sent, the tester will receive an email. </p>
                    </Modal.Body>
                    <Modal.Footer>

                        <button className='btn-brick' onClick={handleCloseInvitations}>
                            Continue
                        </button>
                    </Modal.Footer>
                </Modal>
            </div >

        </>
    )
}

export default MarketplaceStoreDetails;